import { useCallback } from "react";

import { useGenerationSettings } from "~/entities/model";
import { useDraftChatStore } from "~/shared/store/useDraftChatStore";

import { buildRepeatPrefill } from "./build-prefill";

import type { ChatMessage, LegacyGenerationJob } from "~/entities/chat";

/**
 * «Повторить запрос»: кладёт заявку на заполнение промпт-бара
 * текущего чата параметрами уже выполненной генерации. Ничего не отправляет —
 * применит заявку промпт-бар, а «Сгенерировать» жмёт человек.
 */
export function useRepeatGeneration() {
    const settingsQuery = useGenerationSettings();
    const requestPrefill = useDraftChatStore((s) => s.requestPrefill);
    const models = settingsQuery.data;

    // Повторяемо ли сообщение — тот же сборщик, что и при клике: UI не должен
    // показывать действие, которое затем окажется пустышкой (модель убрали,
    // режима больше нет). Пока справочник моделей не загружен — действие скрыто.
    const canRepeat = useCallback(
        (message: ChatMessage, job: LegacyGenerationJob | null): boolean =>
            !!job && buildRepeatPrefill({ message, job, models }) !== null,
        [models],
    );

    const repeat = useCallback(
        (message: ChatMessage, job: LegacyGenerationJob | null): void => {
            if (!job) return;
            const prefill = buildRepeatPrefill({ message, job, models });
            if (!prefill) return;
            requestPrefill(message.chatId, prefill);
        },
        [models, requestPrefill],
    );

    return { canRepeat, repeat };
}
